/**
 * @generated SignedSource<<1d38d46b0be37ff99408da334c2862bd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DuplicateStudyInput = {
  clientMutationId?: string | null;
  studyId: string;
};
export type ProjectPage_DuplicateStudy_Mutation$variables = {
  input: DuplicateStudyInput;
};
export type ProjectPage_DuplicateStudy_Mutation$data = {
  readonly duplicateStudy: {
    readonly study: {
      readonly id: string;
    } | null;
  } | null;
};
export type ProjectPage_DuplicateStudy_Mutation = {
  response: ProjectPage_DuplicateStudy_Mutation$data;
  variables: ProjectPage_DuplicateStudy_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DuplicateStudyPayload",
    "kind": "LinkedField",
    "name": "duplicateStudy",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StudyNode",
        "kind": "LinkedField",
        "name": "study",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProjectPage_DuplicateStudy_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProjectPage_DuplicateStudy_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0939e1e48b5b219a1e0d52d6f952e27f",
    "id": null,
    "metadata": {},
    "name": "ProjectPage_DuplicateStudy_Mutation",
    "operationKind": "mutation",
    "text": "mutation ProjectPage_DuplicateStudy_Mutation(\n  $input: DuplicateStudyInput!\n) {\n  duplicateStudy(input: $input) {\n    study {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "19c84a0661bdfee51a7e49fe5a2774c0";

export default node;
